import React from 'react';

const TaskItem = ({ task, deleteTask, updateTask }) => {
  return (
    <li>
      <h4>{task.title}</h4>
      <p>{task.description}</p>
      <input
        type="checkbox"
        checked={task.completed}
        onChange={() => updateTask(task.id, task.completed)}
      />
      <button onClick={() => deleteTask(task.id)}>Delete</button>
    </li>
  );
};

export default TaskItem;
